export interface Author {
    id: string;
    name: string;
}

export const emptyAuthor : Author = {
    id: '',
    name: ''
}

export default Author;